type ShareCourse = {
  id: string | number
  slug: string
  title: string
  instructorName: string
  cinematic12x5: string
}

type ShareChapter = {
  id: string | number
  slug: string
  title: string
}

export default function getShareLessonProperties(
  course: ShareCourse,
  chapter: ShareChapter,
) {
  return {
    instructorName: course.instructorName,
    classSlug: chapter.title,
    courseId: course.id,
    chapterSlug: chapter.slug,
    cinematic12x5: course.cinematic12x5,
    chapterId: chapter.id,
    title: course.title,
    courseSlug: course.slug,
  }
}
